/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import 'regenerator-runtime/runtime.js';
import { QueryClientProvider } from '@tanstack/react-query';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StudioOccupancy } from './StudioUtilization/StudioOccupancy';
import { queryClient } from './Services/Api/QueryClient';

const studioOccupancyWrappers = document.querySelectorAll('.studio-occupancy-wrapper');

studioOccupancyWrappers.forEach((studioOccupancyWrapper) => {
  const root = ReactDOM.createRoot(studioOccupancyWrapper); // Erstellen einer neuen Root
  root.render(
    <QueryClientProvider client={queryClient}>
      <StudioOccupancy
        studioId={studioOccupancyWrapper.getAttribute('data-studio-id')}
        isNeosBackend={studioOccupancyWrapper.getAttribute('data-is-backend')}
      />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
  );
});
